import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import { ContractorIndividualItem } from '../types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getContractorIndividualDetail: builder.query<ContractorIndividualItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ContractorIndividual/${data.id}`,
      }),
    }),
    changeContractorIndividual: builder.mutation<void, ContractorIndividualItem>({
      query: (data) => ({
        url: `/v1/ContractorIndividual/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createContractorIndividual: builder.mutation<void, Omit<ContractorIndividualItem, 'id'>>({
      query: (data) => ({
        url: '/v1/ContractorIndividual',
        method: 'POST',
        body: data,
      }),
    }),
    deleteContractorIndividual: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ContractorIndividual/${data.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useChangeContractorIndividualMutation,
  useCreateContractorIndividualMutation,
  useDeleteContractorIndividualMutation,
  useGetContractorIndividualDetailQuery,
  useLazyGetContractorIndividualDetailQuery,
} = request;
